import { AEMErrorMessage } from '../../../models';

export const SortFilterNoResultErrorMocks: AEMErrorMessage = {
  action: {
    id: '',
    label: '',
    url: ''
  },
  component: 'sort-filter-no-results',
  errorId: [],
  errorMessageDescription:
    'We’re unable to return any results. Please filter your search and try again.',
  errorMessageTitle: '',
  featureTitle: '',
  type: 'single-error'
};
